module.exports = __webpack_public_path__ + "img/stick_hebergements_hotel_3.89ceb856.svg";